import { type ColDef } from 'ag-grid-community';
import { getRiskScoreClass } from '@shared/utils/risk-score-class.util';

export const WATCHLISTS_PAGE_SIZE = 25;

export const defaultColDef: ColDef = {
  flex: 1,
};

export const getCellClass = getRiskScoreClass;
